import { gql } from 'graphql-request';
import { graphqlClient } from '../client';

const DELETE_PAGE_TAG_MUTATION = gql`
  mutation DeletePageTag($slug: String!, $page_id: ID!, $tag_id: ID!) {
    deletePageTag(slug: $slug, page_id: $page_id, tag_id: $tag_id) {
      id
      success
      message
    }
  }
`;

export interface DeletePageTagResponse {
  deletePageTag: {
    id: string;
    success: boolean;
    message: string;
  };
}

export async function deletePageTagMutation(
  slug: string,
  page_id: string,
  tag_id: string
): Promise<DeletePageTagResponse> {
  return graphqlClient.request<DeletePageTagResponse>(DELETE_PAGE_TAG_MUTATION, {
    slug,
    page_id,
    tag_id
  });
}
